import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useHeader from '../hooks/useHeader';

const Header = ({ variant = 'light' }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  const { headerContent } = useHeader();
  
  const linkClasses = variant === 'dark' 
    ? 'inline-block text-base md:text-lg lg:text-xl text-white hover:text-lime-500 font-medium'
    : 'inline-block text-base md:text-lg lg:text-xl text-teal-900 hover:text-teal-700 font-medium';
  
  const activeLinkClasses = variant === 'dark'
    ? 'inline-block text-base md:text-lg lg:text-xl text-lime-500 font-medium border-b-2 border-lime-500'
    : 'inline-block text-base md:text-lg lg:text-xl text-teal-900 font-medium border-b-2 border-teal-900';
  
  const isActive = (path) => location.pathname === path;

  const isHomePage = location.pathname === '/';
  console.log(headerContent)

    // Fallback values while headerContent is loading (undefined)
  const defaultHomeLogo = '/api/images/IBHome.png';
  const defaultInternalLogo = '/api/images/logoIB.png';

  // Select the appropriate image path based on the route
  const logoSrc = isHomePage
    ? (headerContent?.HomeLogo || defaultHomeLogo)
    : (headerContent?.logo || defaultInternalLogo);

  return (
    <>
      <nav className={variant === 'light' ? 'mx-4 py-6 border-b' : 'py-6'}>
        <div className="container mx-auto px-4">
          <div className="relative flex items-center justify-between">
            <Link className="inline-block" to="/">
              <img className="h-28" src={logoSrc} alt="Island Bridge Exports Logo" />
            </Link>
            <ul className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden md:flex">
              {headerContent?.navigation?.map((navItem) => (
                <li key={navItem.path} className="mr-4 lg:mr-8">
                  <Link className={isActive(navItem.path) ? activeLinkClasses : linkClasses} to={navItem.path}>
                    {navItem.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex items-center justify-end">
              <button 
                className={variant === 'dark' ? 'md:hidden text-white hover:text-lime-500' : 'md:hidden text-teal-900 hover:text-teal-800'}
                onClick={() => setMobileNavOpen(!mobileNavOpen)}
              >
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.19995 23.2H26.7999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                  <path d="M5.19995 16H26.7999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                  <path d="M5.19995 8.79999H26.7999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Navigation */}
      <div className={`${mobileNavOpen ? 'block' : 'hidden'} fixed top-0 left-0 bottom-0 w-full xs:w-5/6 xs:max-w-md z-50`}>
        <div className="fixed inset-0 bg-violet-900 opacity-20" onClick={() => setMobileNavOpen(false)}></div>
        <nav className="relative flex flex-col py-7 px-10 w-full h-full bg-white overflow-y-auto">
          <div className="flex items-center justify-between">
            <Link className="inline-block" to="/">
              <img className="h-12" src={logoSrc} alt="Island Bridge Exports Logo" />
            </Link>
            <button onClick={() => setMobileNavOpen(false)}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.2 8.79999L8.80005 23.2M8.80005 8.79999L23.2 23.2" stroke="#1D1F1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
              </button>
          </div>
          <div className="pt-20 pb-12 mb-auto">
            <ul className="flex-col">
              {headerContent?.navigation?.map((navItem) => (
                <li key={navItem.path} className="mb-6">
                  <Link className={isActive(navItem.path) ? 'inline-block text-teal-900 font-medium border-b-2 border-teal-900' : 'inline-block text-teal-900 hover:text-teal-700 font-medium'} to={navItem.path} onClick={() => setMobileNavOpen(false)}>
                    {navItem.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex items-center">
            <a className="inline-block mr-4 text-teal-900 hover:text-teal-700" href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
